import { render, staticRenderFns } from "./MedicationInfoCard.vue?vue&type=template&id=2afb79ce&scoped=true"
import script from "./MedicationInfoCard.vue?vue&type=script&lang=js"
export * from "./MedicationInfoCard.vue?vue&type=script&lang=js"
import style0 from "./MedicationInfoCard.vue?vue&type=style&index=0&id=2afb79ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb79ce",
  null
  
)

export default component.exports